<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main" class="mt-4">
        <Tabs :tabs="tabs" v-model="activeTabKey" @change="onTabChange">
          <template #banco>
            <BankList v-if="activeTabKey === 'banco'" />
          </template>
          <template #categoria>
            <CostCenterList v-if="activeTabKey === 'categoria'" />
          </template>
          <template #tipoPagamento>
            <TypePaymentList v-if="activeTabKey === 'tipoPagamento'" />
          </template>
        </Tabs>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import Tabs from "@/ui/layout/Tabs";

import BankList from "../bank/BankList.vue";
import CostCenterList from "../costCenter/CostCenterList.vue";
import TypePaymentList from "../typePayment/TypePaymentList.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfigFinanceMain",
  components: { Panel, Tabs, BankList, CostCenterList, TypePaymentList },
  data() {
    return {
      activeTabKey: "banco",
      tabs: [
        { key: "banco", title: "Banco" },
        { key: "categoria", title: "Categoria" },
        { key: "tipoPagamento", title: "Tipo de Pagamento" },
      ],
      panel: {
        module: "Financeiro",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  created() {
    const saved = this.get_FilterStorage(this.$route.name);
    const validKeys = this.tabs.map((t) => t.key);
    this.activeTabKey = saved && validKeys.includes(saved.tabKey) ? saved.tabKey : this.tabs[0].key;

    this._addFilterStorage({ routeName: this.$route.name, tabKey: this.activeTabKey });
  },
  computed: {
    ...mapGetters("generic", ["get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["_addFilterStorage", "removeLoading"]),
    onTabChange(key) {
      this._addFilterStorage({ routeName: this.$route.name, tabKey: key });
    },
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
};
</script>
